import React from 'react';
import Modal from 'styles/blocks/modal/eTriage';

export const SubmitETriage = () => {
  return (
    <Modal.Overlay>
      <Modal.ModalContent>
        <Modal.Text>Submitting your details...</Modal.Text>
        <Modal.Spinner />
      </Modal.ModalContent>
    </Modal.Overlay>
  );
};
